(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationDetailController', CustomerNotificationDetailController);

    CustomerNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomerNotification', 'Customer'];

    function CustomerNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomerNotification, Customer) {
        var vm = this;

        vm.customerNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:customerNotificationUpdate', function(event, result) {
            vm.customerNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
